import { create } from 'zustand';

const useAuthStore = create((set, get) => ({
  token: typeof window !== 'undefined'
    ? localStorage.getItem('aurora_token') || null
    : null,
  user: typeof window !== 'undefined'
    ? (() => {
        try {
          return JSON.parse(localStorage.getItem('aurora_user') || 'null');
        } catch {
          return null;
        }
      })()
    : null,

  setAuth: (token, user) => {
    localStorage.setItem('aurora_token', token);
    localStorage.setItem('aurora_user', JSON.stringify(user));
    set({ token, user });
  },

  logout: () => {
    localStorage.removeItem('aurora_token');
    localStorage.removeItem('aurora_user');
    set({ token: null, user: null });
    window.location.href = 'https://app.auroragh.com/login';
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('aurora_token');
  },

  refreshFromStorage: () => {
    const token = localStorage.getItem('aurora_token');
    try {
      const user = JSON.parse(localStorage.getItem('aurora_user') || 'null');
      set({ token, user });
    } catch {
      set({ token: null, user: null });
    }
  },
}));

export default useAuthStore;